import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appAddressToArray',
  standalone: true,
})
export class AddressToArrayPipe implements PipeTransform {
  transform(value?: {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressLine4?: string;
    postalCode?: string;
  }): string[] {
    if (!value) {
      return [];
    }

    const {
      addressLine1,
      addressLine2,
      addressLine3,
      addressLine4,
      postalCode,
    } = value;
    const addressLines = [
      addressLine1,
      addressLine2,
      addressLine3,
      addressLine4,
      postalCode,
    ].filter(Boolean) as string[];

    return [...new Set(addressLines)];
  }
}
